import { observer } from "mobx-react-lite";

import { useWorkoutEditStore } from "src/workouts/WorkoutEditContext";

import { AmrapDetailedWorkoutItemGroup } from "./AmrapDetailedWorkoutItemGroup";
import {
  BaseDetailedWorkoutItemGroup,
  type WorkoutItemGroupProps,
} from "./BaseDetailedWorkoutItemGroup";
import { FreestyleDetailedWorkoutItemGroup } from "./FreestyleDetailedWorkoutItemGroup";
import { RegularDetailedWorkoutItemGroup } from "./RegularDetailedWorkoutItemGroup";
import { SupersetDetailedWorkoutItemGroup } from "./SupersetDetailedWorkoutItemGroup";
import { TimedDetailedWorkoutItemGroup } from "./TimedDetailedWorkoutItemGroup";

export const DetailedWorkoutItemGroup = observer(
  function DetailedWorkoutItemGroup(props: WorkoutItemGroupProps) {
    const workoutEditStore = useWorkoutEditStore();
    const item = workoutEditStore.getGroupWorkoutItemById(
      props.item.workoutItemId,
    );

    if (item.groupType === "SUPER_SET") {
      return <SupersetDetailedWorkoutItemGroup {...props} />;
    }

    switch (item.format) {
      case "REGULAR":
        return <RegularDetailedWorkoutItemGroup {...props} />;
      case "AMRAP":
        return <AmrapDetailedWorkoutItemGroup {...props} />;
      case "TIMED":
        return <TimedDetailedWorkoutItemGroup {...props} />;
      case "FREESTYLE":
        return <FreestyleDetailedWorkoutItemGroup {...props} />;
      default:
        return <BaseDetailedWorkoutItemGroup {...props} />;
    }
  },
);
